import { ParsedError, ParsedErrorType } from '../models/error';
import { AppNamespace } from '../state/app';

export enum AppActionType {
    initializeApp = 'initializeApp',
    retrieveOrderFailure = 'retrieveOrderFailure',
    removeAppError = 'removeAppError',
    setReloadAfterCheckout = 'setReloadAfterCheckout',
    updatePayinLockStatus = 'updatePayinLockStatus',
    wasExternalPaymentWindowBlocked = 'wasExternalPaymentWindowBlocked',
}

export interface InitializeAppAction {
    type: AppActionType.initializeApp;
    payload: AppNamespace;
}

export interface RetrieveOrderFailureAction {
    type: AppActionType.retrieveOrderFailure;
    payload: ParsedError;
}

export interface RemoveAppErrorAction {
    type: AppActionType.removeAppError;
    payload: ParsedErrorType;
}

export interface SetReloadAfterCheckoutAction {
    type: AppActionType.setReloadAfterCheckout;
    payload: boolean;
}

export interface UpdatePayinLockStatusAction {
    type: AppActionType.updatePayinLockStatus;
    payload: boolean;
}

export interface WasExternalPaymentWindowBlockedAction {
    type: AppActionType.wasExternalPaymentWindowBlocked;
    payload: boolean;
}

export const initializeAppAction = (
    initialData: AppNamespace,
): InitializeAppAction => ({
    type: AppActionType.initializeApp,
    payload: initialData,
});

export const retrieveOrderFailureAction = (
    error: ParsedError,
): RetrieveOrderFailureAction => ({
    type: AppActionType.retrieveOrderFailure,
    payload: error,
});

export const removeAppErrorAction = (
    errorType: ParsedErrorType,
): RemoveAppErrorAction => ({
    type: AppActionType.removeAppError,
    payload: errorType,
});

export const setReloadAfterCheckoutAction = (
    reloadAfterCheckout: boolean,
): SetReloadAfterCheckoutAction => ({
    type: AppActionType.setReloadAfterCheckout,
    payload: reloadAfterCheckout,
});

export const setWasExternalPaymentWindowBlocked = (
    wasExternalPaymentWindowBlocked: boolean,
): WasExternalPaymentWindowBlockedAction => ({
    type: AppActionType.wasExternalPaymentWindowBlocked,
    payload: wasExternalPaymentWindowBlocked,
});

const updatePayinLockStatusAction = (
    locked: boolean,
): UpdatePayinLockStatusAction => ({
    type: AppActionType.updatePayinLockStatus,
    payload: locked,
});

export const lockPayinAmountAction = () => updatePayinLockStatusAction(true);
export const unlockPayinAmountAction = () => updatePayinLockStatusAction(false);

export type AppAction =
    | InitializeAppAction
    | RetrieveOrderFailureAction
    | RemoveAppErrorAction
    | SetReloadAfterCheckoutAction
    | UpdatePayinLockStatusAction
    | WasExternalPaymentWindowBlockedAction;
